import { render, staticRenderFns } from "./news.html?vue&type=template&id=87cc4c4e&scoped=true&external"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc4c4e",
  null
  
)

export default component.exports